import React, { Component } from "react";
import { push } from "connected-react-router";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import _ from 'lodash';

// const ORDER_TYPES_KEY = { LIMIT: 'LIMIT', MARKET: 'MARKET', CONDITION: 'CONDITION' };
import * as actions from "../../../../store/actions";
import {
    TYPE_ORDER_CONDITION, CommonWidgetUtils, initialQuickOrderInputState, LoadStatus, ORDER_TYPE_USE, Role,
    ACTION_METHOD_CONDITION,
    TYPE_ACCOUNT,
    ToastUtil,
    CommonUtils,
    orderActions,
    CommonObject,
    TYPE_SUBMIT_ORDER,
    Random,
    TYPE_DAY,
    initialNonmalOrderInputState
} from "../../../../utils";
import './ConditionOrder.scss';
import ConditionOrderStopLimit from "./ConditionOrderStopLimit/ConditionOrderStopLimit";
import ConditionOrderTrailing, { LIST_TYPE_DELTA } from './ConditionOrderTrailing/ConditionOrderTrailing';
import ConditionOrderConditionOCO from './ConditionOrderConditionOCO/ConditionOrderConditionOCO';
import ConditionOrderConditionGTC from "./ConditionOrderConditionGTC/ConditionOrderConditionGTC";
import ConditionOrderTPSL from "./ConditionOrderTPSL/ConditionOrderTPSL";
import { accountService, tradeApiService, userService } from "services";
import moment from "moment/moment";
import config from '../../../../combineConfig';
import ConditionOrderGuideModal from "./ConditionOrderGuideModal";

const listOrderTypeCondition = [
    {
        title: "Stop limit (STO)",
        value: TYPE_ORDER_CONDITION.STOP_LIMIT,
        enum: 'STO'
    },
    {
        title: "Trailing Stop (TSO)",
        value: TYPE_ORDER_CONDITION.TRAILING_STOP,
        enum: 'TSO'
    },
    {
        title: "OCO",
        value: TYPE_ORDER_CONDITION.OCO,
        enum: 'OCO'
    },
    {
        title: "Take profit/Stop loss (TP/SL)",
        value: TYPE_ORDER_CONDITION.TPSL,
        enum: 'TPSL'
    },
    // {
    //     title: "GTC",
    //     value: TYPE_ORDER_CONDITION.GTC,
    // },
]

export const listActiveTypeCondition = [
    {
        title: "Giá đang khớp",
        value: ACTION_METHOD_CONDITION.FINAL_MATCH_PRICE,
    },
    {
        title: "Giá chào tốt nhất",
        value: ACTION_METHOD_CONDITION.TOP_WAIT_MATCH,
    },
]

const DF_DATA_SUBMIT = {
    ...initialQuickOrderInputState,
}

export const IS_CHECK_PRICE_CONDITION = false
class ConditionOrder extends Component {

    initialState = {
        loadStatus: LoadStatus.NONE,
        dataSubmit: {
            ...DF_DATA_SUBMIT
        },
        isOpenModalActionMethod: false,
        sysvar: null,
        orderPriceStep: null,
        isOpenModalConditionOrderGuide: false
    };

    constructor(props) {
        super(props);
        this.state = {
            ...this.initialState
        }
        this.priceOrderRef = React.createRef();
        this.quantityRef = React.createRef();
        this.containerConditionOrderRef = React.createRef();
    };

    getSysvar = async () => {
        const { currentSymbol, quote, accountQuickOrderInfo, currentAccount, userInfo, setIsOpenModalHaveData } = this.props;
        const { curCustomer, accounts, currentAccountId, typeAccount } = { ...accountQuickOrderInfo }

        if (typeAccount === TYPE_ACCOUNT.FDS) {
            userService.getSysvarByTypeAccount(true)
                .then(responses => {
                    let [orderDate, orderPriceStep] = responses
                    if (orderDate) {
                        this._setState({ sysvar: orderDate[0] })
                    }
                    if (orderPriceStep) {
                        this._setState({ orderPriceStep: orderPriceStep[0] })
                    }
                }).catch(error => {
                    ToastUtil.errorApi(error, 'common.fail-to-load-data');
                })
        }
        else {
            userService.getSysvarByTypeAccount(false)
                .then(responses => {
                    let [orderDate, orderPriceStep] = responses
                    if (orderDate) {
                        this._setState({ sysvar: orderDate[0] })
                    }
                    if (orderPriceStep) {
                        this._setState({ orderPriceStep: orderPriceStep[0] })
                    }
                }).catch(error => {
                    ToastUtil.errorApi(error, 'common.fail-to-load-data');
                })
        }
    }

    isBroker = () => {
        const { role } = this.props;
        return role === Role.BROKER;
    };


    onChangeTypeOrderCondition = (e) => {
        const { placeQuickOrderCurrent } = this.props;
        const { typeOrderCondition } = placeQuickOrderCurrent
        let value = e.target.value
        let obj = {
            typeOrderCondition: e.target.value,
            [typeOrderCondition]: initialNonmalOrderInputState[typeOrderCondition]
        }
        if (value === TYPE_ORDER_CONDITION.TPSL) {
            obj.action = orderActions.SELL
        }
        this.props.updatePlaceQuickOrder(obj, this.props.orderTypeUse)
    }

    _setState = (obj, callback) => {
        if (this.mounted) {
            this.setState(obj, callback);
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }

    async componentDidMount() {
        this.mounted = true
        await this.getSysvar();
        this.props.focusSearchSymbol && this.props.focusSearchSymbol()
    }


    onFinishSuccess = () => {
        const { clearDataPlaceQuickOrder, setIsOpenModalHaveData } = this.props
        ToastUtil.success('trade.place-order.place-order-success');
        CommonUtils.middlewareOrder()
        clearDataPlaceQuickOrder(this.props.orderTypeUse, ['symbolCurrent', 'action', 'typeOrderCondition']);

        setIsOpenModalHaveData("QuickOrder", {
            isOpenModalTradeQuickOrder: false,
            loadStatusQuickOrderModalTrade: LoadStatus.NONE,
            dataShow: {},
        })

    };

    onFinishError = (error) => {
        const { clearDataPlaceQuickOrder, setIsOpenModalHaveData } = this.props
        ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
        setIsOpenModalHaveData("QuickOrder", {
            loadStatusQuickOrderModalTrade: LoadStatus.FAIL,
        })
        CommonUtils.clearTradeAuthInfo();
    };

    componentDidUpdate(prevProps, _prevState) {
        const { placeQuickOrderCurrent, config, updatePlaceQuickOrder, currentSymbol, accountQuickOrderInfo, orderTypeUse,
            socketCIAction, socketSEAction
        } = this.props;
        const { action, editingOrder, typeOrderCondition } = { ...placeQuickOrderCurrent }
        const { currentAccountId, typeAccount } = { ...accountQuickOrderInfo }

        const {
            currentSymbol: prevCurrentSymbol,
            placeQuickOrderCurrent: prevPlaceQuickOrderCurrent,
            accountQuickOrderInfo: prevAccountQuickOrderInfo,
            socketCIAction: prevSocketCIAction, socketSEAction: prevSocketSEAction
        } = prevProps;

        const { typeOrderCondition: prevTypeOrderCondition } = { ...prevPlaceQuickOrderCurrent }
        const { typeAccount: prevTypeAccount } = prevAccountQuickOrderInfo
        if ((typeOrderCondition !== prevTypeOrderCondition)) {
            // this.props.clearDataPlaceQuickOrder(orderTypeUse)
        }

        if (typeAccount !== prevTypeAccount) {
            this.getSysvar()
        }
    }

    getDataShowTypeOrder = () => {
        const { availableTrade } = this.props;
        const {
            quantity,
            quantityValid,
            takeProfit,
            stepTakeProfitPriceValid,
            quoteTakeProfitPriceValid,
            stopLoss,
            stepstopLossPriceValid,
            quotestopLossPriceValid,

            validUntilOrder,
            fromDate,
            toDate,
            activeType
        } = { ...this.props.orderConditionTPSL }

        let data = { ...availableTrade }
        let profitLossTP = 0, profitLossSL = 0, profitLossTPRate = 0, profitLossSLRate = 0
        if (availableTrade) {
            profitLossTP = ((takeProfit - Number(availableTrade.avgcostprice || 0)) * Number(quantity))
            profitLossSL = ((stopLoss - Number(availableTrade.avgcostprice || 0)) * Number(quantity))
            let profitLossTPRate = Number(quantity) > 0 ? ((Number(profitLossTP) / (Number(availableTrade.avgcostprice || 0) * Number(quantity)))) * 100 : 0
            let profitLossSLRate = Number(quantity) > 0 ? ((Number(profitLossSL) / (Number(availableTrade.avgcostprice || 0) * Number(quantity)))) * 100 : 0

            data.profitLossTP = takeProfit ? Number(profitLossTP) : 0 // Lãi lỗ dự kiến = (price - giá vốn) * với KL 
            data.profitLossSL = stopLoss ? Number(profitLossSL) : 0 // Lãi lỗ dự kiến = (price - giá vốn) * với KL
            data.profitLossTPRate = takeProfit && availableTrade.avgcostprice ? Number(profitLossTPRate) : 100// % Lãi lỗ dự kiến = Lãi lỗ dự kiến chia cho ( giá vốn nhân với khối lượng)
            data.profitLossSLRate = stopLoss && availableTrade.avgcostprice ? Number(profitLossSLRate) : 100// % Lãi lỗ dự kiến = Lãi lỗ dự kiến chia cho ( giá vốn nhân với khối lượng)
        }
        return data
    }

    getPlaceOrderData = (typeOrderConditon) => {
        try {
            const { quote, accountQuickOrderInfo, currentSymbol, placeQuickOrderCurrent, orderConditionLimit } = this.props;
            const { curCustomer, accounts, currentAccountId, typeAccount } = { ...accountQuickOrderInfo }
            const { stopPrice, quotePrice,
                quantity, toDate, fromDate, validUntilOrder, activeType,
                delta, priceStep, deltaType,
                stopPriceLo,
                takeProfit, stopLoss, activeTP, activeSL
            } = placeQuickOrderCurrent[typeOrderConditon];
            const { action } = placeQuickOrderCurrent

            let ceilPrice = null;
            let floorPrice = null;
            if (quote != null) {
                ceilPrice = quote['ceiling'];
                floorPrice = quote['floor'];
            }

            //console.log("getPlaceOrderData", this.props.orderConditionLimit)
            let _fromDate = moment(new Date(fromDate)).format(config.app.SERVER_DATE_FORMAT)
            let _toDate = moment(new Date(toDate)).format(config.app.SERVER_DATE_FORMAT)
            // let _fromDate = "13/7/2021"
            // let _toDate = "15/7/2021"

            let data = {}

            switch (typeOrderConditon) {
                case TYPE_ORDER_CONDITION.STOP_LIMIT:
                    data = {
                        // "side": action === orderActions.BUY ? 'buy' : 'sell',
                        // "instrument": currentSymbol && currentSymbol.id,
                        // "qtty": Number(quantity),
                        // "fromdate": "13/07/2021",
                        // "todate": "14/07/2021",
                        // "timetype": "G",
                        // "activetype": "C",
                        // "type": "limit",
                        // "orderprice": Number(stopPrice),
                        // "price": Number(quotePrice)

                        "side": action === orderActions.BUY ? 'buy' : 'sell',
                        "instrument": currentSymbol && currentSymbol.id,
                        "qtty": Number(quantity),
                        "fromdate": _fromDate,
                        "todate": validUntilOrder === TYPE_DAY.DURING_DAY ? _fromDate : _toDate,
                        "timetype": validUntilOrder,
                        "activetype": activeType,
                        "type": "limit",
                        "orderprice": Number(stopPrice),
                        "price": Number(quotePrice)
                    };
                    break;
                case TYPE_ORDER_CONDITION.TRAILING_STOP:
                    let _delta = Number(delta)
                    let _pricestep = Number(priceStep)
                    if (typeAccount === TYPE_ACCOUNT.BASE) { // Cơ sở * 1000
                        if (deltaType == LIST_TYPE_DELTA[0].value) {
                            _delta = _delta * 1000
                        }
                        _pricestep = _pricestep * 1000
                    }
                    data = {
                        "side": action === orderActions.BUY ? 'buy' : 'sell',
                        "instrument": currentSymbol && currentSymbol.id,
                        "qtty": Number(quantity),
                        "fromdate": _fromDate,
                        "todate": validUntilOrder === TYPE_DAY.DURING_DAY ? _fromDate : _toDate,
                        "timetype": validUntilOrder,
                        "activetype": activeType,
                        "type": "limit",
                        "deltatype": deltaType,
                        "deltavalue": _delta,
                        "pricestep": _pricestep,
                    };
                    break;
                case TYPE_ORDER_CONDITION.OCO:
                    data = {
                        "side": action === orderActions.BUY ? 'buy' : 'sell',
                        "instrument": currentSymbol && currentSymbol.id,
                        "qtty": Number(quantity),
                        "priceLO": Number(stopPriceLo),
                        "instrumentLO": currentSymbol && currentSymbol.id,
                        "qttyLO": Number(quantity),
                        "price": Number(quotePrice),
                        "orderprice": Number(stopPrice),
                        "fromdate": _fromDate,
                        "todate": validUntilOrder === TYPE_DAY.DURING_DAY ? _fromDate : _toDate,
                        "timetype": validUntilOrder,
                        "activetype": activeType,
                        "type": "limit"
                    };
                    break;
                case TYPE_ORDER_CONDITION.TPSL:
                    data = {
                        "instrument": currentSymbol && currentSymbol.id,
                        "quoteId": null,

                        "sideTP": "sell",
                        "priceTP": Number(takeProfit),
                        "activePriceTP": Number(activeTP),

                        'qtty': Number(quantity),
                        'sideSL': "sell",
                        'priceSL': stopLoss,
                        "activePriceSL": Number(activeSL),
                        "activetype": activeType,

                        'fromdate': _fromDate,
                        'todate': _toDate,
                    };
                    break;
                case TYPE_ORDER_CONDITION.GTC:
                    data = {
                        "instrument": currentSymbol && currentSymbol.id,
                        "limitPrice": Number(quotePrice),
                        "qty": Number(quantity),
                        "side": action === orderActions.BUY ? orderActions.BUY : orderActions.SELL,
                        "type": "limit",
                        "fromdate": _fromDate,
                        "todate": validUntilOrder === TYPE_DAY.DURING_DAY ? _fromDate : _toDate,
                        "logInfo": `${currentSymbol && currentSymbol.id}-${action}-${Number(quotePrice)}-${Number(quantity)}}`,
                    };
                    break;
                default:
                    break;
            }
            return data;
        } catch (error) {
            ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
        }
    }


    precheckConditionOrder = (typeOrderConditon) => {
        const { loadStatusQuickOrderModalTrade } = this.props;
        if (this.props.loadStatus === LoadStatus.LOADING || this.props.isOpenModalTradeQuickOrder) return;
        try {
            const { userInfo, accountQuickOrderInfo } = this.props;
            const { curCustomer, accounts, currentAccountId } = { ...accountQuickOrderInfo }

            let data = this.getPlaceOrderData(typeOrderConditon);
            let isBroker = this.isBroker();
            let requestId = (isBroker ? 'B' : 'C') + Random.randomOrderRequestId(userInfo.username)
            const precheckAndCb = (resPrecheck) => {
                tradeApiService.initTwoFactorAuth()
                    .then((data) => {
                        if (data) {
                            const { transactionId, tokenid, authtypes, challengeQuestion, authtype, verified } = data;
                            this.props.updateInfoCheckAuth({
                                transactionId: transactionId, tokenid: tokenid, listAuthType: authtypes, challengeQuestion, authtype, verified,
                            })
                            let dataShow = {}
                            if (typeOrderConditon == TYPE_ORDER_CONDITION.TPSL) {
                                dataShow = this.getDataShowTypeOrder();
                            }
                            this.props.updatePlaceQuickOrder({
                                typeSubmitOrder: TYPE_SUBMIT_ORDER.CONDITION_ORDER,
                            }, this.props.orderTypeUse)

                            this.props.setIsOpenModalHaveData("QuickOrder", {
                                isOpenModalTradeQuickOrder: true,
                                onTradeQuickOrderAuthenCallback: (authInfo) => {
                                    this.callApiDoPlaceOrder(authInfo, requestId, typeOrderConditon);
                                },
                                dataShow,
                            })
                        }
                        this.props.setLoadStatus(LoadStatus.LOADED)
                    })
                    .catch(error => {
                        this.props.setLoadStatus(LoadStatus.NONE)
                        ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
                    });
            };

            data.requestId = requestId
            this.props.setLoadStatus(LoadStatus.LOADING)
            switch (typeOrderConditon) {
                case TYPE_ORDER_CONDITION.STOP_LIMIT:
                    accountService.precheckConditionSTO(currentAccountId, data)
                        .then((resPrecheck) => {
                            precheckAndCb(resPrecheck || {});
                        }).catch(error => {
                            this.props.setLoadStatus(LoadStatus.NONE)
                            ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
                        });
                    break;
                case TYPE_ORDER_CONDITION.TRAILING_STOP:
                    accountService.precheckConditionTSO(currentAccountId, data)
                        .then((resPrecheck) => {
                            precheckAndCb(resPrecheck || {});
                        }).catch(error => {
                            this.props.setLoadStatus(LoadStatus.NONE)
                            ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
                        });
                    break;
                case TYPE_ORDER_CONDITION.OCO:
                    accountService.precheckConditionOCO(currentAccountId, data)
                        .then((resPrecheck) => {
                            precheckAndCb(resPrecheck || {});
                        }).catch(error => {
                            this.props.setLoadStatus(LoadStatus.NONE)
                            ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
                        });
                    break;
                case TYPE_ORDER_CONDITION.TPSL:
                    accountService.precheckConditionTPSL(currentAccountId, data)
                        .then((resPrecheck) => {
                            precheckAndCb(resPrecheck || {});
                        }).catch(error => {
                            this.props.setLoadStatus(LoadStatus.NONE)
                            ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
                        });
                    break;
                case TYPE_ORDER_CONDITION.GTC:
                    accountService.precheckConditionGTC(currentAccountId, data)
                        .then((resPrecheck) => {
                            precheckAndCb(resPrecheck || {});
                        }).catch(error => {
                            this.props.setLoadStatus(LoadStatus.NONE)
                            ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
                        });
                    break;
                default:
                    break;
            }
        } catch (error) {
            this.props.setLoadStatus(LoadStatus.NONE)
            ToastUtil.errorApi(error, 'trade.place-order.place-order-fail');
        }
    }

    callApiDoPlaceOrder = (authInfo, requestId, typeOrderConditon) => {
        const { currentSymbol, quote, accountQuickOrderInfo, currentAccount, userInfo, setIsOpenModalHaveData } = this.props;
        try {
            const { curCustomer, accounts, currentAccountId, typeAccount } = { ...accountQuickOrderInfo }
            //console.log("callApiDoPlaceOrder ===>", authInfo)
            let isBroker = this.isBroker();
            let data = this.getPlaceOrderData(typeOrderConditon);
            let _data = { ...data, ...authInfo };
            // submit
            // LoadStatusQuicOrder
            setIsOpenModalHaveData("QuickOrder", {
                loadStatusQuickOrderModalTrade: LoadStatus.LOADING,
            })

            switch (typeOrderConditon) {
                case TYPE_ORDER_CONDITION.STOP_LIMIT:
                    tradeApiService.tradePlaceOrderConditionSTO(currentAccountId, requestId, _data)
                        .then(() => {
                            this.onFinishSuccess();
                        })
                        .catch((error) => {
                            this.onFinishError(error)
                        });
                    break;
                case TYPE_ORDER_CONDITION.TRAILING_STOP:
                    tradeApiService.tradePlaceOrderConditionTSO(currentAccountId, requestId, _data)
                        .then(() => {
                            this.onFinishSuccess();
                        })
                        .catch((error) => {
                            this.onFinishError(error)
                        });
                    break;
                case TYPE_ORDER_CONDITION.OCO:
                    tradeApiService.tradePlaceOrderConditionOCO(currentAccountId, requestId, _data)
                        .then(() => {
                            this.onFinishSuccess();
                        })
                        .catch((error) => {
                            this.onFinishError(error)
                        });
                    break;
                case TYPE_ORDER_CONDITION.TPSL:
                    tradeApiService.tradePlaceOrderConditionTPSL(currentAccountId, requestId, _data)
                        .then(() => {
                            this.onFinishSuccess();
                        })
                        .catch((error) => {
                            this.onFinishError(error)
                        });
                    break;
                case TYPE_ORDER_CONDITION.GTC:
                    tradeApiService.tradePlaceOrderMuchDay(currentAccountId, requestId, _data)
                        .then(() => {
                            this.onFinishSuccess();
                        })
                        .catch((error) => {
                            this.onFinishError(error)
                        });
                    break;
                default:
                    break;
            }

        } catch (error) {
            this.onFinishError(error)
        }
    }

    onToggleGuideModal = () => {
        const { placeQuickOrderCurrent } = this.props;
        const { typeOrderCondition } = { ...placeQuickOrderCurrent }
        const { isOpenModalConditionOrderGuide } = this.state;
        this.setState({ isOpenModalConditionOrderGuide: !isOpenModalConditionOrderGuide });
    }

    getEnumTypeOrder(typeOrderCondition) {
        let found = _.find(listOrderTypeCondition, item => { return item.value === typeOrderCondition });
        if (found) {
            return found.enum;
        } else {
            return '';
        }
    }

    handleScrollBottom = () => {
        this.containerConditionOrderRef && this.containerConditionOrderRef.current && this.containerConditionOrderRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }

    render() {
        const { orderTypeUse, placeQuickOrderCurrent, selectTypeOrderConditionRef } = this.props
        const { loadStatus, isOpenModalConditionOrderGuide } = this.state
        const { typeOrderCondition } = placeQuickOrderCurrent
        let eNumType = this.getEnumTypeOrder(typeOrderCondition);
        return (
            <div className="condition-order" ref={this.containerConditionOrderRef}>
                {isOpenModalConditionOrderGuide && (<ConditionOrderGuideModal
                    isOpen={isOpenModalConditionOrderGuide}
                    onClose={this.onToggleGuideModal}
                    lang={this.props.language}
                    currentType={eNumType}
                    orderTypeData={listOrderTypeCondition}
                />)}

                <div className="type-view price-order">
                    <div className="content content-left text-left txt---500-14-20 label">
                        <FormattedMessage id="trade.place-order.type-order" />
                        &nbsp;
                        <i class='fas fa-info-circle' style={{ cursor: 'pointer' }} onClick={() => { this.onToggleGuideModal() }}></i>
                    </div>
                    <div className="content content-right order-type txt---400-12-20 row-select-order-condition">
                        <div className="custom-form-select-option">
                            <select
                                ref={selectTypeOrderConditionRef}
                                onChange={(e) => this.onChangeTypeOrderCondition(e)}
                                className="focus-item custom-control-select-option"
                                tabIndex={0}
                            >
                                {listOrderTypeCondition && listOrderTypeCondition.map((item, key) => {
                                    return (
                                        <option key={key} value={item.value} selected={typeOrderCondition == item.value ? true : false}>
                                            {item.title}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                        {/* <div className="container-settings item-center">
                            <span style={{ cursor: 'pointer' }} onClick={() => { this._setState({ isOpenModalActionMethod: true }) }}>
                                {this.props.defaultTheme === "dark" ? <IconSettingDark /> : <IconSettingLight />}
                            </span>

                        </div> */}
                    </div>
                </div>
                {typeOrderCondition === TYPE_ORDER_CONDITION.STOP_LIMIT &&
                    <ConditionOrderStopLimit
                        scrollbarRef={this.props.scrollbarRef}
                        orderTypeUse={orderTypeUse}
                        availableTrade={this.props.availableTrade}
                        sysvar={this.state.sysvar}
                        orderPriceStep={this.state.orderPriceStep}
                        precheckConditionOrder={this.precheckConditionOrder}
                        loadStatus={loadStatus}
                        handleScrollBottom={this.handleScrollBottom}
                    />
                }
                {typeOrderCondition === TYPE_ORDER_CONDITION.TRAILING_STOP &&
                    <ConditionOrderTrailing
                        scrollbarRef={this.props.scrollbarRef}
                        orderTypeUse={orderTypeUse}
                        availableTrade={this.props.availableTrade || {}}
                        sysvar={this.state.sysvar}
                        orderPriceStep={this.state.orderPriceStep}
                        precheckConditionOrder={this.precheckConditionOrder}
                        loadStatus={loadStatus}
                        handleScrollBottom={this.handleScrollBottom}
                    />
                }
                {typeOrderCondition === TYPE_ORDER_CONDITION.OCO &&
                    <ConditionOrderConditionOCO
                        orderTypeUse={orderTypeUse}
                        availableTrade={this.props.availableTrade || {}}
                        sysvar={this.state.sysvar}
                        orderPriceStep={this.state.orderPriceStep}
                        precheckConditionOrder={this.precheckConditionOrder}
                        loadStatus={loadStatus}
                        handleScrollBottom={this.handleScrollBottom}
                    />
                }
                {
                    typeOrderCondition === TYPE_ORDER_CONDITION.TPSL &&
                    <ConditionOrderTPSL
                        orderTypeUse={orderTypeUse}
                        availableTrade={this.props.availableTrade || {}}
                        sysvar={this.state.sysvar}
                        orderPriceStep={this.state.orderPriceStep}
                        precheckConditionOrder={this.precheckConditionOrder}
                        getDataShowTypeOrder={this.getDataShowTypeOrder}
                        loadStatus={loadStatus}
                        handleScrollBottom={this.handleScrollBottom}
                    />
                }
                {
                    typeOrderCondition === TYPE_ORDER_CONDITION.GTC &&
                    <ConditionOrderConditionGTC
                        orderTypeUse={orderTypeUse}
                        availableTrade={this.props.availableTrade || {}}
                        sysvar={this.state.sysvar}
                        orderPriceStep={this.state.orderPriceStep}
                        precheckConditionOrder={this.precheckConditionOrder}
                        loadStatus={loadStatus}
                        handleScrollBottom={this.handleScrollBottom}
                    />
                }
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    const { orderTypeUse } = ownProps
    let _placeQuickOrderCurrent = null
    let currentSymbol = null
    let quote = null
    let _accountQuickOrderInfo = null
    let _currentLayoutPageActive = null

    if (orderTypeUse === ORDER_TYPE_USE.QUICK_ORDER) {
        _currentLayoutPageActive = "C&B"
        let _placeQuickOrder = state.orderNew.placeQuickOrder

        currentSymbol = _currentLayoutPageActive && _placeQuickOrder[_currentLayoutPageActive] && _placeQuickOrder[_currentLayoutPageActive]["symbolCurrent"]
        quote = currentSymbol && state.symbol.quotes[currentSymbol["id"]]
        _placeQuickOrderCurrent = _currentLayoutPageActive && _placeQuickOrder[_currentLayoutPageActive]
        _accountQuickOrderInfo = _placeQuickOrderCurrent && _placeQuickOrderCurrent["accountQuickOrderInfo"]

    } else if (orderTypeUse === ORDER_TYPE_USE.NORMAL_ORDER || orderTypeUse === ORDER_TYPE_USE.CONDITION_ORDER) {
        _currentLayoutPageActive = CommonWidgetUtils.getReplaceLayoutPageActive()
        let _placeNormalOrder = state.orderNew.placeNormalOrder
        currentSymbol = _currentLayoutPageActive && _placeNormalOrder[_currentLayoutPageActive] && _placeNormalOrder[_currentLayoutPageActive]["symbolCurrent"]
        quote = currentSymbol && state.symbol.quotes[currentSymbol["id"]]

        let _layoutPage = state.layout.layoutPage[_currentLayoutPageActive]
        _accountQuickOrderInfo = _layoutPage && _layoutPage["accountInfo"]
        _placeQuickOrderCurrent = _currentLayoutPageActive && _placeNormalOrder[_currentLayoutPageActive]
    }
    const userInfo = state.user.userInfo;
    const permissionInfo = userInfo.permissionInfo ? userInfo.permissionInfo : null;
    const instrument = currentSymbol ? state.symbol.instruments[currentSymbol.id] || {} : {};
    return {
        config: state.user.userInfo.config,
        permissionInfo: permissionInfo,
        userInfo: userInfo,
        currentSymbol: currentSymbol,
        instrument: instrument,
        placeQuickOrderCurrent: _placeQuickOrderCurrent,
        accountQuickOrderInfo: _accountQuickOrderInfo,

        quote: quote || CommonObject.emptyObject,
        language: state.app.language,
        role: state.user.userInfo.role,
        showReconfirmOrderConfig: state.app.showReconfirmOrderConfig,

        socketSEAction: state.socketRealtime.socketSEAction,
        socketCIAction: state.socketRealtime.socketCIAction,
        defaultTheme: state.user.userInfo.defaultTheme,

        orderConditionLimit: _placeQuickOrderCurrent["orderConditionLimit"],
        orderConditionTrailing: _placeQuickOrderCurrent["orderConditionTrailing"],
        orderConditionOCO: _placeQuickOrderCurrent["orderConditionOCO"],
        orderConditionTPSL: _placeQuickOrderCurrent["orderConditionTPSL"],
        orderConditionGTC: _placeQuickOrderCurrent["orderConditionGTC"],

        isOpenModalTradeQuickOrder: state.layout.listIsOpenModal["C&B"]["QuickOrder"].isOpenModalTradeQuickOrder,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        navigate: (path) => dispatch(push(path)),
        updatePlaceQuickOrder: (data, typeOrder) => dispatch(actions.updatePlaceQuickOrder(data, typeOrder)),
        clearDataPlaceQuickOrder: (typeOrder, arrKeep) => dispatch(actions.clearDataPlaceQuickOrder(typeOrder, arrKeep)),
        updatedLayoutPage: (data, key) => dispatch(actions.updatedLayoutPage(data, key)),
        setIsOpenModalHaveData: (key, data) => dispatch(actions.setIsOpenModalHaveData(key, data)),
        fetchSymbolOrderbook: (symbolId) => dispatch(actions.fetchSymbolOrderbook(symbolId)),
        updateInfoCheckAuth: (data, key) => dispatch(actions.updateInfoCheckAuth(data, key)),

    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ConditionOrder);
